import { LUCK_PRINT_WIDTH_PX } from "./protocol";

export function buildGsV0RasterPacket(
  rasterData: Uint8Array,
  widthPx: number,
  heightPx: number,
): Uint8Array {
  const widthBytes = Math.ceil(widthPx / 8);
  const header = new Uint8Array([
    0x1d,
    0x76,
    0x30,
    0x00,
    widthBytes & 0xff,
    (widthBytes >> 8) & 0xff,
    heightPx & 0xff,
    (heightPx >> 8) & 0xff,
  ]);
  const packet = new Uint8Array(header.length + rasterData.length);
  packet.set(header, 0);
  packet.set(rasterData, header.length);
  return packet;
}

export function expectedRasterByteLength(
  widthPx = LUCK_PRINT_WIDTH_PX,
  heightPx: number,
): number {
  return Math.ceil(widthPx / 8) * heightPx;
}
